import React  from 'react';
import logo from './logo.svg';
import './App.css';
import Market from './market.js';

function App() {
  return (
    <div className="App" >
      <Market/>
    </div>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js